<template>
  <div class="part-item projectSchema">
    <p class="part-title">系统架构图及简要说明
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('frame')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openFrame"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <span class="content-title">简要说明：</span>
      <div
        class="content-text"
        v-if="!formInfo.frame_content"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.frame_content"
        v-html="formInfo.frame_content"
      ></div>
      <div class="clearfix"></div>
      <div class="content-text"></div>
      <div class="content-text">
        <ul id="schemaPics">
          <li
            v-for="(item, index) in infoFrameFileList"
            :key="index"
          ><img
              :src="item.src"
              :alt="item.name"
            ></li>
        </ul>
      </div>
    </div>
    <p class="part-title">实验教学
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('experiment_tech')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openExperimentTech"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <span class="content-title">开发技术：</span>
      <div class="content-text">
        {{ infoExperimentTech.tech.v1 ? 'VR，' : '' }}
        {{ infoExperimentTech.tech.v2 ? 'AR，' : '' }}
        {{ infoExperimentTech.tech.v3 ? 'MR，' : '' }}
        {{ infoExperimentTech.tech.v4 ? '3D仿真，' : '' }}
        {{ infoExperimentTech.tech.v5 ? '二维动画，' : '' }}
        {{ infoExperimentTech.tech.v6 ? 'HTML5，' : '' }}
        {{ infoExperimentTech.tech.v7 ? '其他：' : '' }}
        <span
          class="otherTech_content"
          v-if="infoExperimentTech.tech.v7"
        >{{ infoExperimentTech.tech.otherText }}</span>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">开发工具：</span>
      <div class="content-text">
        {{ infoExperimentTech.tool.v1 ? 'Unity3D，' : '' }}
        {{ infoExperimentTech.tool.v2 ? '3D Studio Max，' : '' }}
        {{ infoExperimentTech.tool.v3 ? 'Maya，' : '' }}
        {{ infoExperimentTech.tool.v4 ? 'ZBrush，' : '' }}
        {{ infoExperimentTech.tool.v5 ? 'SketchUp，' : '' }}
        {{ infoExperimentTech.tool.v6 ? 'Adobe Flash，' : '' }}
        {{ infoExperimentTech.tool.v7 ? 'Unreal Development Kit，' : '' }}
        {{ infoExperimentTech.tool.v8 ? 'Animate CC，' : '' }}
        {{ infoExperimentTech.tool.v9 ? 'Blender，' : '' }}
        {{ infoExperimentTech.tool.v10 ? 'Visual Studio，' : '' }}
        {{ infoExperimentTech.tool.v11 ? '其他' : '' }}
        <span
          v-if="infoExperimentTech.tool.v11"
          class="otherTool_content"
        >{{ infoExperimentTech.tool.otherText }}</span>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">运行环境：</span>
      <div class="content-text">
        <h3>服务器</h3>
        CPU<span class="underline_txt">{{ infoExperimentTech.env.server.cpu }}</span>核、
        内存<span class="underline_txt">{{ infoExperimentTech.env.server.mem }}</span>GB、
        磁盘<span class="underline_txt">{{ infoExperimentTech.env.server.disk }}</span>GB、
        显存<span class="underline_txt">{{ infoExperimentTech.env.server.gpu_size }}</span>GB、
        GPU型号<span class="underline_txt">{{ infoExperimentTech.env.server.gpu_no }}</span>
        <h3>操作系统</h3>
        {{ infoExperimentTech.env.sys.window_server ? 'Windows Server，' : '' }}
        {{ infoExperimentTech.env.sys.window_server ? '具体版本：' : ''  }}
        <span
          v-if="infoExperimentTech.env.sys.window_server"
          class="underline_txt"
        >{{ infoExperimentTech.env.sys.window_server_v }}</span>
        <br v-if="infoExperimentTech.env.sys.window_server">
        {{ infoExperimentTech.env.sys.linux ? 'Linux，' : '' }}
        {{ infoExperimentTech.env.sys.linux ? '具体版本：' : ''  }}
        <span
          v-if="infoExperimentTech.env.sys.linux"
          class="underline_txt"
        >{{ infoExperimentTech.env.sys.linux_v }}</span>
        <br v-if="infoExperimentTech.env.sys.linux">
        {{ infoExperimentTech.env.sys.other ? infoExperimentTech.env.sys.other_name : '' }}
        {{ infoExperimentTech.env.sys.other ? '具体版本：' : ''  }}
        <span
          v-if="infoExperimentTech.env.sys.other"
          class="underline_txt"
        >{{ infoExperimentTech.env.sys.other_version }}</span>
        <h3>数据库</h3>
        {{ infoExperimentTech.env.db.v1 ? 'Mysql，' : ''}}
        {{ infoExperimentTech.env.db.v2 ? 'SQL Server，' : ''}}
        {{ infoExperimentTech.env.db.v3 ? 'Oracle，' : ''}}
        {{ infoExperimentTech.env.db.v4 ? '其他' : ''}}
        <span
          v-if="infoExperimentTech.env.db.v4"
          class="otherBase_content"
        >{{ infoExperimentTech.env.db.otherText }}</span>
        <br>
        备注说明
        <span class="underline_txt">{{ infoExperimentTech.env.db.des }}</span>
        <br>
        是否支持云渲染：
        <span
          v-if="infoExperimentTech.cloud_support == 1"
          class="underline_txt"
        >是</span>
        <span
          v-if="infoExperimentTech.cloud_support == 0"
          class="underline_txt"
        >否</span>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">实验品质：</span>
      <div class="content-text">
        单场景模型总面数<span class="underline_txt">{{ infoExperimentTech.quality.situation_count }}</span>个
        <br>
        贴图分辨率<span class="underline_txt">{{ infoExperimentTech.quality.pic_x }}</span>px
        *<span class="underline_txt">{{ infoExperimentTech.quality.pic_y }}</span>px
        <br>
        每帧渲染次数<span class="underline_txt">{{ infoExperimentTech.quality.times }}</span>calls
        <br>
        动作反馈时间<span class="underline_txt">{{ infoExperimentTech.quality.action_time }}</span>ms
        <br>
        显示刷新率<span class="underline_txt">{{ infoExperimentTech.quality.refresh }}</span>FPS
        <br>
        分辨率<span class="underline_txt">{{ infoExperimentTech.quality.x }}</span>ppi
        *<span class="underline_txt">{{ infoExperimentTech.quality.y }}</span>ppi
        <br>
        其他<span class="underline_txt">{{ infoExperimentTech.quality.other }}</span>
        <br>
      </div>
    </div>

    <div
      class="form_overlay"
      :style="formatShowWindow(showWindow.frame)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style=""
      >
        <div class="form_title">系统架构图及简要说明</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.frame = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div
          class="form_content"
          style=""
        >
          <form style="">
            <div
              class="item"
              style=""
            >
              <span class="label"><i class="require"></i>简要说明</span>
              <vue-ueditor-wrap
                style="margin-left: 120px;"
                v-model="formFrame.frame_content"
                :config="editorConfig"
                editor-id="editor-demo-18"
              ></vue-ueditor-wrap>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>架构图</span>
              <div class="item-box clearfix">
                <div class="schemaPic-list"></div>
                <div class="schemaPic-list">
                  <p
                    class="m-b-sm"
                    v-for="(item, index) in frameFileList"
                    :key="index"
                  >
                    <a :href="item.src">{{ item.name }}</a>
                    <span
                      @click="removeFrameFile(index)"
                      class="del"
                      title="删除"
                    >×</span>
                  </p>
                </div>
                <span
                  class="button"
                  @click="showImageWindow"
                >上传</span>
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.frame = false"
            class="button close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveFrame"
            class="button"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      :style="formatShowWindow(showWindow.experiment_tech)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style=""
      >
        <div class="form_title">实验教学</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.experiment_tech = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div
          class="form_content"
          style=""
        >
          <form id="testProForm">
            <div class="item">
              <span class="label"><i class="require"></i>开发技术</span>
              <div class="k-container">
                <label class="m-r">
                  <input
                    v-model="experimentTech.tech.v1"
                    type="checkbox"
                    value="1"
                    autocomplete="new-password"
                  >VR</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tech.v2"
                    type="checkbox"
                    value="2"
                    autocomplete="new-password"
                  >AR</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tech.v3"
                    type="checkbox"
                    value="3"
                    autocomplete="new-password"
                  >MR</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tech.v4"
                    type="checkbox"
                    value="4"
                    autocomplete="new-password"
                  >3D仿真</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tech.v5"
                    type="checkbox"
                    value="5"
                    autocomplete="new-password"
                  >二维动画</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tech.v6"
                    type="checkbox"
                    value="6"
                    autocomplete="new-password"
                  >HTML5</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tech.v7"
                    @click="experimentTech.tech.otherText = experimentTech.tech.v7 ? experimentTech.tech.otherText : ''"
                    type="checkbox"
                    value="7"
                    autocomplete="new-password"
                  >其他</label>
              </div>
            </div>
            <div
              class="item otherTech"
              v-show="experimentTech.tech.v7"
            >
              <span class="label"><i class="require"></i></span>
              <input
                v-model="experimentTech.tech.otherText"
                type="text"
                class="form-control"
                autocomplete="new-password"
                maxlength="30"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>开发工具</span>
              <div class="k-container">
                <label class="m-r">
                  <input
                    v-model="experimentTech.tool.v1"
                    type="checkbox"
                    value="1"
                    autocomplete="new-password"
                  >Unity3D</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tool.v2"
                    type="checkbox"
                    value="2"
                    autocomplete="new-password"
                  >3D Studio Max</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tool.v3"
                    type="checkbox"
                    value="3"
                    autocomplete="new-password"
                  >Maya</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tool.v4"
                    type="checkbox"
                    value="4"
                    autocomplete="new-password"
                  >ZBrush</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tool.v5"
                    type="checkbox"
                    value="5"
                    autocomplete="new-password"
                  >SketchUp</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tool.v6"
                    type="checkbox"
                    value="6"
                    autocomplete="new-password"
                  >Adobe Flash</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tool.v7"
                    type="checkbox"
                    value="7"
                    autocomplete="new-password"
                  >Unreal Development Kit</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tool.v8"
                    type="checkbox"
                    value="8"
                    autocomplete="new-password"
                  >Animate CC</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tool.v9"
                    type="checkbox"
                    value="9"
                    autocomplete="new-password"
                  >Blender</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tool.v10"
                    type="checkbox"
                    value="10"
                    autocomplete="new-password"
                  >Visual Studio</label>
                <label class="m-r">
                  <input
                    v-model="experimentTech.tool.v11"
                    @click="experimentTech.tool.otherText = experimentTech.tool.v11 ? experimentTech.tool.otherText : ''"
                    type="checkbox"
                    value="11"
                    autocomplete="new-password"
                  >其他</label>
              </div>
            </div>
            <div
              class="item otherTool"
              v-show="experimentTech.tool.v11"
            >
              <span class="label"><i class="require"></i></span>
              <input
                v-model="experimentTech.tool.otherText"
                type="text"
                class="form-control"
                autocomplete="new-password"
                maxlength="30"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>运行环境</span>
              <div class="k-container runSys">
                <h3>服务器</h3>
                <p>
                  <span class="runText">CPU</span>
                  <input
                    v-model="experimentTech.env.server.cpu"
                    type="text"
                    class="form-control runInput"
                    autocomplete="new-password"
                    maxlength="30"
                  >
                  <span class="runText">核、内存</span>
                  <input
                    v-model="experimentTech.env.server.mem"
                    type="text"
                    class="form-control runInput"
                    autocomplete="new-password"
                    maxlength="30"
                  >
                  <span class="runText">GB、磁盘</span>
                  <input
                    v-model="experimentTech.env.server.disk"
                    type="text"
                    class="form-control runInput"
                    autocomplete="new-password"
                    maxlength="30"
                  >
                  <span class="runText">GB、显存</span>
                  <input
                    v-model="experimentTech.env.server.gpu_size"
                    type="text"
                    class="form-control runInput"
                    autocomplete="new-password"
                    maxlength="30"
                  >
                  <span class="runText">GB、GPU型号</span>
                  <input
                    v-model="experimentTech.env.server.gpu_no"
                    type="text"
                    class="form-control runInput"
                    autocomplete="new-password"
                    maxlength="30"
                  >
                </p>
                <h3>操作系统</h3>
                <p>
                  <label class="m-r">
                    <input
                      v-model="experimentTech.env.sys.window_server"
                      @click="experimentTech.env.sys.window_server_v = experimentTech.env.sys.window_server ? experimentTech.env.sys.window_server_v : ''"
                      type="checkbox"
                      value="1"
                      autocomplete="new-password"
                      maxlength="30"
                    >Windows Server</label>
                  <span
                    class="winVersion"
                    v-show="experimentTech.env.sys.window_server"
                  >
                    <span class="runText">具体版本</span>
                    <input
                      v-model="experimentTech.env.sys.window_server_v"
                      type="text"
                      class="form-control runInput"
                      autocomplete="new-password"
                      maxlength="30"
                    >
                  </span>
                </p>
                <p>
                  <label class="m-r">
                    <input
                      v-model="experimentTech.env.sys.linux"
                      @click="experimentTech.env.sys.linux_v = experimentTech.env.sys.linux ? experimentTech.env.sys.linux_v : ''"
                      type="checkbox"
                      value="2"
                      autocomplete="new-password"
                    >Linux</label>
                  <span
                    class="linuxVersion"
                    v-show="experimentTech.env.sys.linux"
                  >
                    <span class="runText">具体版本</span>
                    <input
                      v-model="experimentTech.env.sys.linux_v"
                      type="text"
                      class="form-control runInput"
                      autocomplete="new-password"
                      maxlength="30"
                    >
                  </span>
                </p>
                <p>
                  <label class="m-r">
                    <input
                      v-model="experimentTech.env.sys.other"
                      @click="experimentTech.env.sys.other_name = experimentTech.env.sys.other ? experimentTech.env.sys.other_name : '', experimentTech.env.sys.other_version = experimentTech.env.sys.other ? experimentTech.env.sys.other_version : ''"
                      type="checkbox"
                      value="3"
                      autocomplete="new-password"
                    >其他</label>
                  <span
                    class="otherSystem"
                    v-show="experimentTech.env.sys.other"
                  >
                    <span class="runText">操作系统</span>
                    <input
                      v-model="experimentTech.env.sys.other_name"
                      type="text"
                      class="form-control runInput"
                      autocomplete="new-password"
                      maxlength="30"
                    >
                  </span>
                  <span
                    class="otherSystem"
                    v-show="experimentTech.env.sys.other"
                  >
                    <span class="runText">具体版本</span>
                    <input
                      v-model="experimentTech.env.sys.other_version"
                      type="text"
                      class="form-control runInput"
                      autocomplete="new-password"
                      maxlength="30"
                    >
                  </span>
                </p>
                <div class="clearfix"></div>
                <h3>数据库</h3>
                <p>
                  <label class="m-r">
                    <input
                      v-model="experimentTech.env.db.v1"
                      type="checkbox"
                      value="1"
                      autocomplete="new-password"
                    >Mysql</label>
                  <label class="m-r">
                    <input
                      v-model="experimentTech.env.db.v2"
                      type="checkbox"
                      value="2"
                      autocomplete="new-password"
                    >SQL Server</label>
                  <label class="m-r">
                    <input
                      v-model="experimentTech.env.db.v3"
                      type="checkbox"
                      value="3"
                      autocomplete="new-password"
                    >Oracle</label>
                  <label class="m-r">
                    <input
                      v-model="experimentTech.env.db.v4"
                      @click="experimentTech.env.db.otherText = experimentTech.env.db.v4 ? experimentTech.env.db.otherText : ''"
                      type="checkbox"
                      value="4"
                      autocomplete="new-password"
                    >其他</label>
                  <input
                    v-show="experimentTech.env.db.v4"
                    v-model="experimentTech.env.db.otherText"
                    type="text"
                    class="form-control otherBase"
                    autocomplete="new-password"
                    maxlength="30"
                  >
                </p>
                <p>备注说明<br>
                  <textarea
                    v-model="experimentTech.env.db.des"
                    rows="5"
                    class="form-control"
                    placeholder="需要其他硬件设备或服务器数量多于1台时请说明"
                  ></textarea>
                </p>
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>是否支持云渲染</span>
              <select
                v-model="experimentTech.cloud_support"
                type="text"
                class="form-control isCloudDraw"
              >
                <option value="">请选择</option>
                <option value="1">是</option>
                <option value="0">否</option>
              </select>
            </div>
            <div class="item proQuality">
              <span class="label"><i class="require"></i>实验品质</span>
              <div class="k-container">
                <div class="p-item">
                  <label class="p-item-title">单场景模型总面数</label>
                  <input
                    v-model="experimentTech.quality.situation_count"
                    type="text"
                    class="short"
                    autocomplete="new-password"
                    maxlength="10"
                  >
                  <span class="p-item-unit">个</span>
                </div>
                <div class="p-item">
                  <label class="p-item-title">贴图分辨率</label>
                  <span class="line">
                    <input
                      v-model="experimentTech.quality.pic_x"
                      type="text"
                      class="short"
                      autocomplete="new-password"
                      maxlength="10"
                    >
                    <i class="s-unit">px</i>
                  </span>
                  <span class="p-item-space">*</span>
                  <span class="line">
                    <input
                      v-model="experimentTech.quality.pic_y"
                      type="text"
                      class="short"
                      autocomplete="new-password"
                      maxlength="10"
                    >
                    <i class="s-unit">px</i>
                  </span>
                </div>
                <div class="p-item">
                  <label class="p-item-title">每帧渲染次数</label>
                  <input
                    v-model="experimentTech.quality.times"
                    type="text"
                    class="short"
                    autocomplete="new-password"
                    maxlength="10"
                  >
                  <span class="p-item-unit">calls</span>
                </div>
                <div class="p-item">
                  <label class="p-item-title">动作反馈时间</label>
                  <input
                    v-model="experimentTech.quality.action_time"
                    type="text"
                    class="short"
                    autocomplete="new-password"
                    maxlength="10"
                  >
                  <span class="p-item-unit">ms</span>
                </div>
                <div class="p-item">
                  <label class="p-item-title">显示刷新率</label>
                  <input
                    v-model="experimentTech.quality.refresh"
                    type="text"
                    class="short"
                    autocomplete="new-password"
                    maxlength="5"
                  >
                  <span class="p-item-unit">FPS</span>
                </div>
                <div class="p-item">
                  <label class="p-item-title">分辨率</label>
                  <span class="line">
                    <input
                      v-model="experimentTech.quality.x"
                      type="text"
                      class="short"
                      autocomplete="new-password"
                      maxlength="10"
                    >
                    <i class="s-unit">ppi</i>
                  </span>
                  <span class="p-item-space">*</span>
                  <span class="line">
                    <input
                      v-model="experimentTech.quality.y"
                      type="text"
                      class="short"
                      autocomplete="new-password"
                      maxlength="5"
                    >
                    <i class="s-unit">ppi</i>
                  </span>
                </div>
                <div class="p-item">
                  <label class="p-item-title">其他</label>
                  <input
                    v-model="experimentTech.quality.other"
                    type="text"
                    class="normal"
                    autocomplete="new-password"
                    maxlength="30"
                  >
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.experiment_tech = false"
            class="button close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveExperimentTech"
            class="button"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      id="dialog_overlay"
      class=""
      :style="formatShowWindow(showWindow.proPicOption.proPicDialog)"
    >
      <div id="dialog_bg"></div>
      <div
        id="dialog_panel"
        style="margin-left: -137px; margin-top: -84px;"
        class=""
      >
        <div id="dialog_panel_bg"></div>
        <div id="dialog_title">选择图片</div>
        <div id="dialog_content">
          <div
            class="imgType"
            style="margin-bottom:10px;"
            id="imgType"
          >允许上传的图片格式：jpg</div>
          <div
            id="thumbPreview"
            v-show="showWindow.proPicOption.proPicImgPreview"
          ><img ref="previewImg"></div>
          <div>
            <input
              id="imageFile"
              type="file"
              accept=".jpg"
              ref="imageFile"
              @change="imageFileChange"
            >
          </div>
        </div>
        <div id="dialog_control">
          <a
            href="javascript:void(0)"
            @click="hideImageWindow"
            id="dialog_close"
            class="button"
            style="display: inline-block;"
          >取消</a>
          <a
            href="javascript:void(0)"
            @click="confirmImage"
            id="dialog_ok"
            class="button"
            style="display: inline-block;"
          >确认</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'

export default {
  name: 'ExperimentMaintainFrame',
  props: ['isShow', 'expId'],
  components: {
    VueUeditorWrap
  },
  data () {
    return {
      editorConfig: {
        UEDITOR_HOME_URL: '/UE/',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        initialFrameWidth: '100%',
        initialFrameHeight: 300
      },
      formInfo: {
        frame_content: '',
        frame_file: '',
        frame_experiment_tech: ''
      },
      showWindow: {
        frame: false,
        proPic: false,
        proPicOption: {
          proPicDialog: false,
          proPicImgPreview: false,
          uploaded_img: '',
          uploaded_name: ''
        },
        experiment_tech: false
      },
      formFrame: {
        frame_content: '',
        frame_file: ''
      },
      formExperimentTech: {
        frame_experiment_tech: ''
      },
      infoFrameFileList: [],
      frameFileList: [],
      defaultExperimentTech: {
        tech: {
          v1: false,
          v2: false,
          v3: false,
          v4: false,
          v5: false,
          v6: false,
          v7: false,
          otherText: ''
        },
        tool: {
          v1: false,
          v2: false,
          v3: false,
          v4: false,
          v5: false,
          v6: false,
          v7: false,
          v8: false,
          v9: false,
          v10: false,
          v11: false,
          otherText: ''
        },
        env: {
          server: {
            cpu: '',
            mem: '',
            disk: '',
            gpu_size: '',
            gpu_no: ''
          },
          sys: {
            window_server: false,
            window_server_v: '',
            linux: false,
            linux_v: '',
            other: false,
            other_name: '',
            other_version: ''
          },
          db: {
            v1: false,
            v2: false,
            v3: false,
            v4: false,
            otherText: '',
            des: ''
          }
        },
        cloud_support: '',
        quality: {
          situation_count: '',
          pic_x: '',
          pic_y: '',
          times: '',
          action_time: '',
          refresh: '',
          x: '',
          y: '',
          other: ''
        }
      },
      infoExperimentTech: {
        tech: {
          v1: false,
          v2: false,
          v3: false,
          v4: false,
          v5: false,
          v6: false,
          v7: false,
          otherText: ''
        },
        tool: {
          v1: false,
          v2: false,
          v3: false,
          v4: false,
          v5: false,
          v6: false,
          v7: false,
          v8: false,
          v9: false,
          v10: false,
          v11: false,
          otherText: ''
        },
        env: {
          server: {
            cpu: '',
            mem: '',
            disk: '',
            gpu_size: '',
            gpu_no: ''
          },
          sys: {
            window_server: false,
            window_server_v: '',
            linux: false,
            linux_v: '',
            other: false,
            other_name: '',
            other_version: ''
          },
          db: {
            v1: false,
            v2: false,
            v3: false,
            v4: false,
            otherText: '',
            des: ''
          }
        },
        cloud_support: '',
        quality: {
          situation_count: '',
          pic_x: '',
          pic_y: '',
          times: '',
          action_time: '',
          refresh: '',
          x: '',
          y: '',
          other: ''
        }
      },
      experimentTech: {
        tech: {
          v1: false,
          v2: false,
          v3: false,
          v4: false,
          v5: false,
          v6: false,
          v7: false,
          otherText: ''
        },
        tool: {
          v1: false,
          v2: false,
          v3: false,
          v4: false,
          v5: false,
          v6: false,
          v7: false,
          v8: false,
          v9: false,
          v10: false,
          v11: false,
          otherText: ''
        },
        env: {
          server: {
            cpu: '',
            mem: '',
            disk: '',
            gpu_size: '',
            gpu_no: ''
          },
          sys: {
            window_server: false,
            window_server_v: '',
            linux: false,
            linux_v: '',
            other: false,
            other_name: '',
            other_version: ''
          },
          db: {
            v1: false,
            v2: false,
            v3: false,
            v4: false,
            otherText: '',
            des: ''
          }
        },
        cloud_support: '',
        quality: {
          situation_count: '',
          pic_x: '',
          pic_y: '',
          times: '',
          action_time: '',
          refresh: '',
          x: '',
          y: '',
          other: ''
        }
      },
      sensitiveWord: []
    }
  },
  methods: {
    removeFrameFile(index) {
      this.frameFileList.splice(index, 1)
    },
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.infoFrameFileList = this.formInfo.frame_file ? JSON.parse(this.formInfo.frame_file) : []
        if (this.formInfo.frame_experiment_tech) {
          this.infoExperimentTech = JSON.parse(this.formInfo.frame_experiment_tech)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    showImageWindow() {
      this.showWindow.proPicOption.proPicImgPreview = false
      this.showWindow.proPicOption.proPicDialog = true
    },
    hideImageWindow() {
      this.showWindow.proPicOption.proPicDialog = false
    },
    async imageFileChange() {
      const uploadUrl = '/files/' + this.$refs.imageFile.files[0].name
      await this.$http.put(uploadUrl, this.$refs.imageFile.files[0]).then((data) => {
        this.showWindow.proPicOption.uploaded_img = data
        this.showWindow.proPicOption.uploaded_name = this.$refs.imageFile.files[0].name
        this.showWindow.proPicOption.proPicImgPreview = true
        this.$refs.previewImg.src = data
      }).catch(() => {
        this.$layer.msg('上传失败！')
      })
    },
    confirmImage() {
      if (this.showWindow.frame) {
        this.frameFileList.push({
          src: this.showWindow.proPicOption.uploaded_img,
          name: this.showWindow.proPicOption.uploaded_name
        })
      }
      this.hideImageWindow()
    },
    openFrame() {
      this.formFrame.frame_content = this.formInfo.frame_content
      this.formFrame.frame_file = this.formInfo.frame_file
      this.frameFileList = this.formFrame.frame_file ? JSON.parse(this.formFrame.frame_file) : []
      this.showWindow.frame = true
    },
    async saveFrame(category = 0) {
      if (category !== 1) {
        this.formFrame.frame_file = JSON.stringify(this.frameFileList)
      }
      const url = '/experiment/' + this.expId + '/'
      const isRight = this.utils.getWords(this.formFrame.frame_content, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.put(url, this.formFrame).then((data) => {
        if (data.id) {
          this.formInfo.frame_content = this.formFrame.frame_content
          this.formInfo.frame_file = this.formFrame.frame_file
          this.infoFrameFileList = this.formInfo.frame_file ? JSON.parse(this.formInfo.frame_file) : []
          this.showWindow.frame = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    openExperimentTech() {
      this.showWindow.experiment_tech = true
      this.experimentTech = this.formInfo.frame_experiment_tech ? JSON.parse(this.formInfo.frame_experiment_tech) : JSON.parse(JSON.stringify(this.defaultExperimentTech))
    },
    async saveExperimentTech(category = 0) {
      if (category === 1) {
        this.formExperimentTech.frame_experiment_tech = JSON.stringify(this.defaultExperimentTech)
      } else {
        this.formExperimentTech.frame_experiment_tech = JSON.stringify(this.experimentTech)
      }
      const url = '/experiment/' + this.expId + '/'
      await this.$http.put(url, this.formExperimentTech).then((data) => {
        if (data.id) {
          this.formInfo.frame_experiment_tech = data.frame_experiment_tech
          this.infoExperimentTech = this.formInfo.frame_experiment_tech ? JSON.parse(this.formInfo.frame_experiment_tech) : JSON.parse(JSON.stringify(this.defaultExperimentTech))
          this.showWindow.experiment_tech = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    clearItem(categgory) {
      switch (categgory) {
        case 'frame':
          this.formFrame = {
            frame_content: '',
            frame_file: ''
          }
          this.saveFrame(1)
          break
        case 'experiment_tech':
          this.saveExperimentTech(1)
          break
      }
    },
    // 获取敏感词
    async getSensitiveWord() {
      await this.$http.get('/sensitiveword/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        if (data.results.length) {
          data.results.forEach(item => {
            if (item.words) {
              const wordList = item.words.split('\n')
              for (let i = 0; i < wordList.length; i++) {
                this.sensitiveWord.push(wordList[i])
              }
            }
          })
        } else {
          this.sensitiveWord = []
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  async mounted() {
    await this.getInfo()
    this.getSensitiveWord()
  }
}
</script>

<style scoped src="../../../../assets/css/project-detail.css"></style>
<style scoped src="../../../../assets/css/table.css"></style>
<style scoped src="../../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
.m-r {
  margin-right: 15px;
}

.form_content {
  padding: 20px 0;
}

.form_content .label {
  width: 120px;
  line-height: 1.6em;
  margin-top: 6px;
  white-space: initial;
  padding: 0;
}

.form_content .label a {
  color: #73D6CA;
  margin-left: 5px;
  font-size: 13px;
  text-decoration: underline;
}

.form_content textarea {
  width: inherit;
}

.form_content .item select {
  padding-top: 6px;
  /*height:inherit;*/
}

.form_content .item input[type="text"],
.form_content .item input[type="password"],
.form_content .item input[type="number"] {
  padding: 6px 12px;
  height: inherit;
  line-height: 1.42857143;
}

.form_content .item input[type="text"]:focus,
.form_content .item input[type="password"]:focus,
.form_content .item input[type="number"]:focus,
.form_content .item select:focus {
  border-color: #099;
}

.form_content .simple {
  padding: 6px 12px;
}

.form_control {
  padding: 0;
  text-align: center;
}

.form_control a {
  float: none;
  display: inline-block;
  margin: 0 10px;
}

.form_control a#next-step,
.form_control a#prev-step {
  background-color: #f25050;
}

span.underline_txt {
  margin: 0;
  padding: 0 10px;
  border-bottom: 1px solid #666;
}

.content-text h3 {
  font-size: 14px;
  color: inherit;
  margin: 10px 0 5px 0;
}
.content-text h3:nth-child(1) {
  margin-top: 0px;
}

.content .container {
  width: 1200px;
  margin: 0 auto;
  visibility: visible;
}

.center_content {
  .box-wrap {
    margin-top: 20px;
    padding: 40px;
    background: #fff;
    box-sizing: border-box;
  }

  .title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-right: 160px;
    padding-left: 20px;

    .title-btns {
      position: absolute;
      top: 0;
      right: 0;

      > a {
        margin-right: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: #3399ff;
        cursor: pointer;

        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .title:before {
    content: "";
    width: 4px;
    height: 1em;
    background-color: #73D6CA;
    position: absolute;
    left: 0;
    top: 16px;
  }

  .mbox .lBox {
    float: left;
    width: 600px;

    .detail-base {
      font-size: 16px;
      padding: 20px 0;
      height: 376px;
      box-sizing: border-box;
      overflow-y: auto;

      .detail-item {
        display: inline-block;
        margin-right: 30px;
        padding: 10px 0;
      }

      .detail-intro {
        padding: 10px 0;

        .label {
          float: left;
        }

        p {
          padding-left: 80px;
        }
      }

      .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        overflow: hidden;
      }
    }
  }

  .label {
    width: 100px;
    padding-right: 10px;
  }

  .mbox .rBox {
    float: right;
    width: 460px;

    .preview {
      padding: 6px 20px;
      border: 1px solid #73D6CA;
      color: #73D6CA;
      border-radius: 3px;
    }

    .submit {
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
    }

    .imgCover {
      width: 100%;
      height: 306px;
      margin-top: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .upload {
      width: 140px;
      height: 40px;
      line-height: 40px;
      display: block;
      margin: 10px auto;
      text-align: center;
      background: #21b295;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .part-content {
    .part-new-table {
      margin: 10px 0;
      border: 1px solid #ebebeb;
      width: 100%;
      max-width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      background-color: transparent;
      tr th {
        background-color: #f8faff;
        color: #999;
        font-weight: normal;
      }
    }
    .part-new-table tr th,
    .part-new-table tr td {
      padding: 8px;
      line-height: 1.42857143;
      vertical-align: middle;
      border: 1px solid #ebebeb;
      text-align: center;
    }
  }
  .item-box {
    float: left;
    width: 302px;
    position: relative;
  }

  .uploadImgPreview li img {
    width: 100%;
    margin-top: 5px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
  }

  .video-box {
    .lBox {
      float: left;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }

    .video-wrap {
      width: 400px;
      height: 226px;
      margin: 10px auto 0;
      background: #000;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .rBox {
      float: right;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }
  }

  .menu-box {
    overflow: hidden;
    border-bottom: 1px solid #eee;

    ul {
      li {
        text-align: center;
        float: left;
        margin-right: 10px;

        a {
          display: block;
          padding: 10px;
          font-size: 16px;
          color: #002900;
          text-decoration: none;
          border-bottom: 3px solid #fff;
        }

        &:hover a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }

      .onActive {
        a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }
    }
  }

  .part {
    min-height: 390px;
    margin-top: 30px;
  }
}
.form_contentEdit .label {
  width: 100px !important;
}
.form_content .k-container {
  max-width: 640px;
  width: 640px;
  .item-table {
    width: 640px;
    input {
      width: 100%;
      border: none;
    }
  }
  .item-table th,
  .item-table td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    padding-bottom: 1px;
  }
}
.teachItem {
  p {
    font-weight: 600;
  }
  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}
.teachEdit {
  .m-r {
    color: #333333;
    font-weight: 500;
    display: inline-block;
    width: 150px;
    input {
      position: relative;
      top: -1px;
      margin-right: 7px;
    }
  }
  .file {
    color: #0b80ff;
    display: block;
    .del {
      margin-left: 10px;
      font-size: 22px;
      color: #c7254e;
      cursor: pointer;
      margin: 0;
      background: transparent;
      top: 3px;
      position: relative;
    }
  }
  .upload {
    display: block;
    text-align: center;
    width: 55px;
    line-height: 30px;
    background: #f19830;
    color: #fff;
    cursor: pointer;
  }
}
.warn {
  p {
    font-size: 12px;
    color: #df3d3e;
  }
  span {
    font-size: 12px;
    color: #337ab7;
    cursor: pointer;
  }
}
.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}
.teach_Item {
  color: #666;
  .text {
    width: 40px !important;
    height: 20px !important ;
    line-height: 23px !important;
    border: none !important;
    text-align: center;
    border-bottom: 1px solid #999 !important;
  }
}
.form_overlay {
  z-index: 100 !important;
}

.file-upload {
  z-index: 200 !important;
}

.menu-list > li.on a,
.menu-list > li:hover a {
  color: #73D6CA !important;
  border-color: #73D6CA !important;
}
.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}
.del-icon {
  color: #ff0000;
  position: relative;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  right: 17px;
  top: -12px;
  cursor: pointer;
}
.url_link {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
}
.url_link::-webkit-scrollbar {
  display: none;
}
.form_control {
  text-align: center;
}
.form_control a {
  float: none;
  display: inline-block;
}
.addOtherUser {
  display: inline-block;
  color: #ffffff;
  margin-left: 15px;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 4px;
  background-color: #028c8c;
  border-color: #028c8c;
  cursor: pointer;
}
.infor span {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
  display: inline-block;
  margin-bottom: 10px;
  display: inline-block;
}
.infor span i {
  color: #999;
}
.person {
  position: relative;
  overflow: hidden;
}
.person_symbol {
  position: absolute;
  left: -20px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg); /* Internet Explorer 9*/
  -moz-transform: rotate(-45deg); /* Firefox */
  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
  -o-transform: rotate(-45deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}
.tips {
  margin-bottom: 10px;
  color: rgb(144, 144, 144);
}
.content_underline {
  text-decoration: underline;
  margin: 0 10px;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: inherit;
  font-weight: 500;
  line-height: inherit;
  color: inherit;
}

a:focus,
a:hover {
  text-decoration: none;
}

ol {
  margin: 0;
}

::-webkit-input-placeholder,
::-webkit-textarea-placeholder {
  color: #ccc;
}

:-moz-placeholder {
  color: #ccc;
}

::-moz-placeholder {
  color: #ccc;
}

.audit {
  position: relative;
}

:-ms-input-placeholder,
:-ms-textarea-placeholder {
  color: #ccc;
}

input {
  outline: none;
}

.bottom p {
  margin: 0;
}

.fangsong {
  /*font-family:"FangSong", "FANGSONG";*/
  font-family: "宋体";
  color: #909090;
}

.center_content .menu .mbox {
  background-color: #fff;
  padding: 20px 40px;
  margin: 20px auto;
  position: relative;
}

span.declare-tip-btn {
  position: absolute;
  color: #f60;
  cursor: pointer;
  top: 10px;
  left: 60px;
  z-index: 1;
  text-decoration: underline;
}

.center_content .menu .mbox .Lmbox {
  width: 60%;
}

.center_content .menu .mbox .Rmbox {
  width: 35%;
}

.center_content .menu .mbox .Lmbox .title {
  position: relative;
  padding: 1em 0 0 1em;
}

.center_content .menu .mbox .Lmbox .title:after {
  content: "";
  display: table;
  clear: both;
  height: 0;
}

.center_content .menu .mbox .Lmbox .title:before {
  content: "";
  width: 4px;
  height: 1em;
  background-color: #73D6CA;
  position: absolute;
  left: 0;
  top: 1.3em;
}

.center_content .menu .mbox .Lmbox .title a.audit {
  margin-right: 10px;
}

.center_content .menu .mbox .Lmbox .title .btn {
  padding: 5px 10px;
}

.infor {
  margin-top: 20px;
  padding: 0;
}

.infor p {
  margin: 0;
}

.center_content .menu .mbox .Lmbox .infor span i {
  color: #999;
}

.btn-warning {
  background-color: #ff6600;
  border: 1px solid #e55c00;
  box-shadow: 2px 2px 3px rgba(255, 102, 0, 0.25);
  -webkit-box-shadow: 2px 2px 3px rgba(255, 102, 0, 0.25);
}

.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active.focus,
.btn-warning.active:focus,
.btn-warning.active:hover,
.btn-warning:active.focus,
.btn-warning:active:focus,
.btn-warning:active:hover {
  background-color: #f96400;
  border: 1px solid #e55c00;
}

.btn-success {
  background-color: #009900;
  border: 1px solid #018c01;
  box-shadow: 2px 2px 3px rgba(0, 153, 0, 0.25);
  -webkit-box-shadow: 2px 2px 3px rgba(0, 153, 0, 0.25);
}

.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active.focus,
.btn-success.active:focus,
.btn-success.active:hover,
.btn-success:active.focus,
.btn-success:active:focus,
.btn-success:active:hover {
  background-color: #009300;
}

.center_content .menu .mbox .Lmbox .title a.print {
  float: right;
}

.center_content .menu .mbox .Lmbox .title a.edit {
  float: none;
  color: #f60;
  margin-left: 15px;
}

.center_content .menu .mbox .Lmbox .img-edit a.edit,
.center_content .menu .mbox .Lmbox .txt a.edit,
.center_content .menu .mbox .Rmbox .videoInfo a.edit {
  float: none;
  color: #999;
  margin-left: 12px;
  cursor: pointer;
}

.center_content .menu .mbox .Lmbox a.edit.active {
  color: #50abf2 !important;
}

.center_content .menu .mbox .Lmbox .img a.edit i,
.center_content .menu .mbox .Lmbox .txt a.edit i,
.center_content .menu .mbox .Rmbox .videoInfo a.edit i {
  margin-right: 5px;
  font-size: 14px;
}

.center_content .menu .mbox .Lmbox .txt {
  width: 100%;
  float: left;
  margin-top: 0;
}

.center_content .menu .mbox .Lmbox .other {
  float: left;
}

.center_content .menu .mbox .Lmbox .img {
  width: 130px;
  float: right;
}

.center_content .menu .mbox .Lmbox .img span {
  margin-bottom: 6px;
}

.img-preview-box {
  width: 248px;
  border: 1px solid #f1f1f1;
}

.brief-box {
  width: 400px;
  margin-left: 20px;
}

.center_content .menu .mbox .Rmbox .video {
  width: 390px;
}

.video-noitems {
  color: #eee;
  text-align: center;
  padding-top: 75px;
}

.video-noitems .iconfont {
  font-size: 32px;
}

.video-noitems span {
  display: block;
  margin-top: 10px;
}

.videoInfo {
  text-align: center;
  margin: 20px 0;
}

#viewProPicDemo {
  margin-left: 10px;
  position: absolute;
  left: 100%;
  width: 4em;
  top: 2px;
  cursor: pointer;
  height: 2em;
  overflow: hidden;
}

#viewProPicDemo:after {
  content: "查看示例";
  position: absolute;
  color: #337ab7;
  left: 0;
  top: -2px;
  z-index: 5;
}

#viewProPicDemo img {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
}

.viewer-button {
  background-color: #000;
}

.form_content {
  padding: 20px 0;
}

.form_content .label {
  width: 120px;
  line-height: 1.6em;
  margin-top: 6px;
  white-space: initial;
  padding: 0;
}

.form_content .label a {
  color: #73D6CA;
  margin-left: 5px;
  font-size: 13px;
  text-decoration: underline;
}

.form_content textarea {
  width: inherit;
}

.form_content .item select {
  padding-top: 6px;
  /*height:inherit;*/
}

.form_content .item input[type="text"],
.form_content .item input[type="password"],
.form_content .item input[type="number"] {
  padding: 6px 12px;
  height: inherit;
  line-height: 1.42857143;
}

.form_content .item input[type="text"]:focus,
.form_content .item input[type="password"]:focus,
.form_content .item input[type="number"]:focus,
.form_content .item select:focus {
  border-color: #099;
}

.form_content .simple {
  padding: 6px 12px;
}

.form_control {
  padding: 0;
  text-align: center;
}

.form_control a {
  float: none;
  display: inline-block;
  margin: 0 10px;
}

.form_control a#next-step,
.form_control a#prev-step {
  background-color: #f25050;
}

.info-box {
  width: 1200px;
  margin: 20px auto;
  overflow: hidden;
}

.menu-box {
  width: 250px;
  float: left;
  background-color: #fff;
  padding: 34px 46px;
}

.menu-list > li {
  text-align: center;
}

.menu-list > li > a {
  display: block;
  padding: 10px 0;
  border-radius: 30px;
  -webkit-border-radius: 30px;
  margin: 10px 0;
  background-color: #eee;
  border: 1px solid #e4e4e4;
  color: #666;
}

.menu-list > li > a i {
  display: none;
  font-size: 12px;
  margin: 0 5px;
}

.menu-list > li > a i:first-of-type {
  font-size: 14px;
}

.menu-list > li > a.on,
.menu-list > li > a:hover {
  color: #fff;
  text-decoration: none;
  background: #73D6CA;
  background: -moz-linear-gradient(-45deg, #73D6CA 0%, #5c8aff 100%);
  background: -webkit-linear-gradient(-45deg, #73D6CA 0%, #5c8aff 100%);
  background: linear-gradient(135deg, #73D6CA 0%, #5c8aff 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#73D6CA', endColorstr='#5c8aff', GradientType=1);
}

.menu-list > li > a:focus {
  text-decoration: none;
}

.menu-list > li > a.on i {
  display: inline-block;
}

.center_content .part {
  float: right;
  width: 930px;
  min-height: 390px;
  margin: 0;
  background-color: #fff;
  padding: 20px;
}

.part-title {
  margin: 20px 0;
  color: #000;
  padding-left: 1em;
  font-size: 16px;
  position: relative;
  display: inline-block;
  width: 100%;
}

.part-title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 3px;
  width: 3px;
  height: 1em;
  background-color: #73D6CA;
}

.incharge-box .part-title {
  border-bottom: 0;
  padding-left: 20px;
  font-size: 15px;
  color: #333;
  position: relative;
  padding: 0 0 20px 20px;
  margin: 0;
}

.incharge-box .part-title:before {
  content: "";
  width: 10px;
  height: 10px;
  background: #73D6CA;
  position: absolute;
  left: 0;
  top: 5px;
}

.incharge-box .part-title:after {
  content: "";
  width: 4px;
  height: 4px;
  background: #fff;
  position: absolute;
  left: 3px;
  top: 8px;
}

.part-sub-title {
  float: right;
}

.part-title > a,
.part-sub-title > a {
  float: right;
  font-size: 14px;
  color: #999;
  margin-left: 15px;
}

.part-title > a:hover,
.part-sub-title > a:hover {
  text-decoration: none;
}

.part-title > a > i,
.part-sub-title > a > i {
  margin-right: 5px;
}

.part-table,
.part-content {
  margin-bottom: 20px;
  border-radius: 3px;
  -webkit-border-radius: 3px;
}

.table-caption {
  /*border: 1px solid #ebebeb;*/
  border-bottom: 0;
  padding-left: 20px;
  font-size: 15px;
  color: #333;
  position: relative;
  padding: 0 0 20px 20px;
}

.table-caption:before {
  content: "";
  width: 10px;
  height: 10px;
  background: #73D6CA;
  position: absolute;
  left: 0;
  top: 5px;
}

.table-caption:after {
  content: "";
  width: 4px;
  height: 4px;
  background: #fff;
  position: absolute;
  left: 3px;
  top: 8px;
}

.table.part-table tr th,
.table.part-table tr td {
  text-align: center;
  color: #333;
  width: 200px;
  vertical-align: middle;
  word-break: break-all;
}

.part-table tr th {
  width: 110px;
  background-color: #f8faff;
  color: #999;
  font-weight: normal;
}

.part-table tr:hover {
  background-color: #f9f9f9;
}

.part-content {
  border: 1px solid #f0f0f0;
  padding: 20px;
  color: #666666;
  min-height: 110px;
  overflow: hidden;
  word-break: break-all;
}

.part-tip {
  /*padding-left:1em;*/
  margin-bottom: 10px;
}

.part-tip > .teamPeoTotal {
  color: #73D6CA;
}

.part-tip > .schoolPeoNum {
  color: #009900;
}

.part-tip > .societyPeoNum {
  color: #ff6600;
}

.left-content,
.right-content {
  width: 50%;
  float: left;
}

.right-content {
  float: right;
  /*border-left:1px solid #f0f0f0;*/
  padding-left: 2%;
}

.left-content {
  border-right: 1px solid #f0f0f0;
  padding-right: 2%;
}

.content-text,
.content-title {
  float: left;
}

.content-text {
  margin-bottom: 10px;
  word-break: break-all;
}

.content-text:last-of-type {
  margin-bottom: 0;
}

.content-text span {
  /*border-bottom: 1px solid #666;*/
  /*padding: 0px 0.5em;*/
  margin-left: 5px;
}

.content-text img {
  max-width: 100%;
}

.c-content {
  width: 820px;
}

#uList .l_header th {
  text-align: center;
}

.form_overlay {
  z-index: 1000;
}

#file-upload-overlay {
  z-index: 1003;
}

.item-box {
  float: left;
  width: 302px;
  position: relative;
}
.content-text {
  width: 100%;
}
#schemaPics {
  width: 100%;
  overflow: hidden;
}

#schemaPics li {
  float: left;
  width: 100%;
  height: 100%;
  margin: 5px;
  overflow: hidden;
  cursor: pointer;
}
#schemaPics li img {
  width: 100%;
  height: 100%;
}

.form_panel,
.other_panel {
  min-width: 620px;
}

.form_content .item .button {
  height: 34px;
  line-height: 34px;
}

.form_content .item .txtbox {
  width: 380px;
  height: auto;
}

.form_content .item .txtbox .accord {
  padding: 10px 0;
}

.title_text {
  max-width: 15em;
  float: left;
  margin: 2px 0 0 0;
  width: 200px;
}
/*重置laydate.js*/
.laydate_body .laydate_top {
  padding: 0;
}

.laydate_body .laydate_ym .laydate_yms {
  border: 0;
}

.laydate_body .laydate_bottom .laydate_btn {
  top: 0;
}

.tooltip {
  position: absolute;
  left: 50%;
  bottom: 100%;
  width: 260px;
  font-size: 14px;
  font-weight: normal;
  margin-left: -148px;
  margin-bottom: 10px;
  padding: 12px 18px;
  background: #5f5e5c;
  background: -moz-linear-gradient(top, #5f5e5c 0%, #353334 100%);
  background: -webkit-linear-gradient(top, #5f5e5c 0%, #353334 100%);
  background: linear-gradient(to bottom, #5f5e5c 0%, #353334 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#5f5e5c', endColorstr='#353334', GradientType=0);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.35);
  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.35);
  /*display:none;*/
  color: #fff;
  line-height: initial;
  text-align: left;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
}

.audit:hover .tooltip {
  opacity: 1;
  visibility: visible;
}

.tooltip:after {
  content: "";
  display: block;
  height: 0px;
  width: 0px;
  border-left: 6px solid transparent;
  border-top: 6px solid #353334;
  border-right: 6px solid transparent;
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -6px;
}

#uList table .action {
  width: auto;
}

#uList td {
  line-height: 2em;
}
/*2018-09-18*/
#testResultForm label,
#testProForm label {
  font-weight: normal;
  cursor: pointer;
  margin-bottom: 0;
  vertical-align: middle;
}

#testResultForm input {
  margin: 0 5px 0 0;
  position: relative;
  top: -1px;
}

.otherRequire_content:before,
.otherTech_content:before,
.otherTool_content:before,
.otherSystem_content:before,
.otherBase_content:before {
  content: "—";
  margin-right: 5px;
}

span.otherSystem,
span.winVersion,
span.linuxVersion {
  display: inline-block;
  vertical-align: middle;
}

.edui-scale {
  box-sizing: unset !important;
  -webkit-box-sizing: unset !important;
  -moz-box-sizing: unset !important;
}
/*2018-09-26*/
.form_content .item select.duty_select {
  width: 95px;
  float: left;
  margin-right: 8px;
}

.form_content .item select.duty_select:last-of-type {
  margin-right: 0;
}
/*2018-11-30*/
.cN-pagination {
  float: none;
}
/*2019-05-21*/
#basisEditor .edui-editor,
#stepExplainEditor .edui-editor,
#methodsEditor .edui-editor,
#baseRequireEditor .edui-editor,
#domainEditor .edui-editor,
#pcosEditor .edui-editor,
#otherPcosEditor .edui-editor,
#otherCardEditor .edui-editor,
#schemaRecord .edui-editor,
#thinkingEditor .edui-editor,
#methodEditor .edui-editor,
#evaluationEditor .edui-editor,
#rangeEditor .edui-editor,
#continueEditor .edui-editor,
#sharePlanEditor .edui-editor,
#toSocietyEditor .edui-editor,
#commitmentEditor .edui-editor,
#basisEditor .edui-editor {
  margin-left: 160px;
}
/*2019-06-25*/
.videoTab {
  margin: 20px 0 10px;
  border-bottom: 1px solid #d6d6d6;
}

.videoType {
  background: #fff;
  border: 1px solid #d6d6d6;
  border-bottom: 0;
  float: left;
  height: 32px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  color: #333;
  padding: 0 10px;
  margin-left: -1px;
  position: relative;
}

.videoType:hover,
.videoType:focus {
  text-decoration: none;
  color: inherit;
  outline: none;
}

.videoType.on {
  background: #fbfbfb;
  color: #73D6CA;
}

.videoType.on:after {
  content: "";
  height: 2px;
  background-color: #73D6CA;
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
}

.runSys h3 {
  font-size: 14px;
  margin: 5px 0;
  color: #555;
}

.runSys p {
  color: #555;
  overflow: hidden;
}

.form_content .item input[type="text"].runInput {
  float: left;
  width: 120px;
  margin: 5px;
}

.runText {
  float: left;
  line-height: 44px;
}

.content-text h3 {
  font-size: 14px;
  color: inherit;
  margin: 5px 0;
}

.content-text h3:first-of-type {
  margin-top: 0;
}

span.underline_txt {
  margin: 0;
  padding: 0 10px;
  border-bottom: 1px solid #666;
}

.file-upload {
  -webkit-box-sizing: unset;
  box-sizing: unset;
}
/*2019-07-30*/
.errsList {
  margin: 0;
  padding: 0 1em 0 0;
  margin-left: 2em;
}

.errsList > li {
  list-style-type: decimal;
}

.table tbody tr td.leader-name {
  position: relative;
  cursor: pointer;
  padding-left: 20px;
}

.leader-name .incharge-icon {
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  z-index: 1;
  width: 42px;
  height: 42px;
  background: url(/images/incharge-icon.png) no-repeat center center;
  background-size: 100% 100%;
}

.main-leader,
.other-team,
.incharge-box {
  background: #fcfdff;
  border: 1px solid #f0f0f3;
  padding: 20px;
  border-radius: 3px;
  margin-bottom: 20px;
}

.incharge-box {
  padding: 20px 20px 0;
}

.mainMember,
.otherMember {
  margin-bottom: 0;
}

.projectTeam .cN-pagination {
  display: none;
}

.add-one-course {
  background: #73D6CA;
  color: #fff;
  width: 32px;
  height: 32px;
  text-align: center;
  cursor: pointer;
  line-height: 32px;
}

.course-box .item-input,
.subject-box .item-input,
.author-container .item-input {
  margin-bottom: 10px;
}

.del {
  background: #e4e4e4;
  color: #ff0000;
  height: 34px;
  line-height: 30px;
  margin-left: 0;
  margin-right: 0;
  text-align: center;
  width: 32px;
  display: inline-block;
  cursor: pointer;
  vertical-align: middle;
}

.ceprove-list {
  width: 380px;
}

.attach-list .del,
.attach-list01 .del,
.ceprove-list .del,
#attachForm .del,
#serviceForm .del,
.ceother-list .del {
  background: none;
  margin-left: 5px;
}

.attach-list .del .iconfont,
.attach-list01 .del .iconfont,
.ceprove-list .del .iconfont,
.ceother-list .del .iconfont {
  font-size: 12px;
}

.course-box .del .iconfont {
  font-size: 12px;
}

.form_content .item select,
.form_content .item input[type="text"],
.form_content .item input[type="password"],
.form_content .item input[type="number"],
.form_content .k-container,
.form_content textarea,
.form_content .simple {
  width: 380px;
}

.form_content .item .item-input > input {
  width: 348px;
}

.name-item {
  /*border: 1px solid #dddddd;*/
  width: 380px;
  margin-bottom: 10px;
}

.form_content .item .name-item input {
  width: 100%;
  /* border: none; */
}

.name-item .name {
  display: block;
  width: 100%;
}

#form_overlay .form_panel {
  width: 620px;
}

.form_content .imgMsg {
  padding-left: 160px;
}

.form_content .imgMsg.word-count {
  text-align: right;
}

#basis-words {
  display: none;
}

#essential-words {
  padding-right: 30px;
  text-align: right;
}

.form_content .k-container {
  max-width: 380px;
}

.form_content .course-wrap,
.form_content .subject-wrap {
  position: relative;
}

.form_content .course-wrap .imgMsg,
.form_content .subject-wrap .imgMsg {
  padding-left: 0;
  position: absolute;
  bottom: 0;
  right: 0;
}

.form_content .item input.expTypeOther {
  width: 160px;
  border-top: 0;
  border-left: 0;
  border-right: 0;
}

.form_content .item select.lang-select {
  width: 120px;
}

.item-table {
  width: 380px;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
}

.item-table th,
.item-table td {
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  text-align: center;
  padding-bottom: 1px;
}

.form_content .term-item .k-container {
  max-width: 380px;
  float: none;
  padding-left: 160px;
}

.form_content .item .item-table input[type="number"],
.form_content .item .item-table input[type="text"],
.form_content .item .item-table textarea {
  width: 100%;
  border: none;
}

.form_content .item .item-table .termNum {
  width: 50px;
}

.item.main-team {
  display: none;
}

.form_content textarea.auto {
  width: 100%;
  min-height: 120px;
  padding: 15px;
  box-sizing: border-box;
}

#mainTeamTeach-words {
  padding-left: 0;
  text-align: right;
}

.part-content pre {
  font-family: Microsoft YaHei, "微软雅黑", "宋体", Helvetica, STHeiti STXihei,
    Microsoft JhengHei, Arial !important;
  border: none;
  background: none;
  color: #666666;
  font-size: 14px;
  margin: 0;
  padding: 0;
  line-height: 1.5em;
  border-radius: 0;
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
}

.content-text.no-float {
  float: none;
}

.points-content .content-text {
  padding: 10px 0 10px 2em;
}

.points-content .points-text .content-title {
  padding-left: 2em;
}

.points-content .points-text .content-text {
  padding-left: 4em;
}

.editor .form_content .k-container {
  max-width: 640px;
  width: 640px;
}

.form_content .item .add-one-step {
  width: 42px;
  float: right;
  background: #009900;
  border-color: #009900;
}

.form_content .item .add-one-step:hover {
  background: #026902;
}

.form_content .item .save-local-step {
  float: right;
  margin-right: 20px;
  font-size: 14px;
  display: none;
}

.form_content .item .save-local-step .iconfont {
  font-size: 13px;
}

.part-content .hour {
  text-decoration: underline;
  padding: 0 10px 2px;
}

.editor .form_content .k-container.step-container {
  width: 800px;
  max-width: 100%;
}

.step-box .item-table {
  width: 800px;
  margin-bottom: 20px;
}

.form_content .step-box .item-table th {
  line-height: 1;
  padding: 12px 0;
}

.form_content .step-box .item-table th p {
  line-height: 1;
  color: #333;
  margin: 0;
}

.f_list .item-table tr:hover {
  background: none;
}

.f_list .item-table tr.l_header:hover {
  background: #f5f7fc;
}

.step-box .item-table td {
  padding: 1px 5px;
}

.form_content .item .step-box .item-table input[type="number"] {
  height: 42px;
  line-height: 42px;
  text-align: center;
}

.form_content .item .step-box .item-table textarea {
  text-align: center;
  height: 120px;
  line-height: 1.5em;
}

.step-box .wordCount {
  font-size: 12px;
  width: 100%;
  display: block;
  color: #009900;
}

.form_content .step-box .check-label {
  height: 24px;
  line-height: 24px;
  margin-bottom: 0;
}

.part-step-table p {
  margin-bottom: 0;
}

.commitment-incharge {
  text-align: right;
  /*padding-right: 150px;*/
  line-height: 24px;
  position: relative;
}

.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}

.upload-signPic {
  color: #73D6CA;
  text-decoration: underline;
}

.upload-signPic:hover {
  text-decoration: underline;
}

.commitment-incharge .del-icon {
  color: #ff0000;
  position: absolute;
  border: 1px solid #ddd;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  right: 0;
  top: -7px;
  cursor: pointer;
}

.commitment-incharge .del-icon:hover {
  border-color: #ff0000;
  background: #f9f9f9;
}

.commitment-incharge .del-icon .iconfont {
  font-size: 12px;
  transform: scale(0.75);
  display: inline-block;
  margin-top: -2px;
}

.commitment-year {
  text-align: right;
  padding-right: 50px;
}

.commitment-year .blank {
  padding: 0 10px;
}

.form_content .item input.short {
  width: 120px;
}

#testProForm .p-item {
  margin-bottom: 8px;
  position: relative;
}

#testProForm label.p-item-title {
  display: inline-block;
  width: 130px;
}

.p-item .line {
  position: relative;
}

.p-item-space {
  color: #999;
  padding: 0 5px;
}

i.s-unit {
  position: absolute;
  right: 10px;
  color: #999;
}

.share-plan .item-table,
.continue-build .item-table {
  width: 640px;
}

.form_content #buildingForm .item .item-table input {
  width: 100%;
}

.part-build-table {
  margin: 10px 0;
  border: 1px solid #ebebeb;
  width: 100%;
  max-width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  background-color: transparent;
}

.part-build-table tr th,
.part-build-table tr td {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: middle;
  border: 1px solid #ebebeb;
  text-align: center;
}

.part-build-table tr th {
  background-color: #f8faff;
  color: #999;
  font-weight: normal;
}

.form_content .item .author-container .item-input > input,
.form_content .item .author-container .item-input > select {
  width: 100px;
  vertical-align: middle;
  height: 34px;
}

.form_content .item .author-container .item-input > select {
  width: 148px;
}

.content-text .author-name {
  display: inline-block;
  min-width: 200px;
  margin-right: 20px;
}

#attach_overlay .form_content .label {
  width: 350px;
}

.form_content #serviceForm .item .button {
  display: inline-block;
  vertical-align: middle;
}

.form_content #serviceForm .imgMsg {
  padding-left: 0;
}

#serviceForm .phone-input {
  width: 140px;
  display: inline-block;
}

#serviceForm .phone-input1,
#serviceForm .otherService1 {
  margin-right: 20px;
}

#serviceForm .teamNum,
#serviceForm .techNum,
#serviceForm .serviceTime {
  width: 90px;
  border-top: none;
  border-left: none;
  border-right: none;
  text-align: center;
}

.form_content #serviceForm .k-container {
  max-width: 530px;
  width: 530px;
}

#serviceForm input.otherMetaFile,
#serviceForm input.syOtherMetaFile,
#serviceForm input.otherService {
  width: 130px;
  display: inline-block;
  vertical-align: middle;
}

.form_content #serviceForm .check-label {
  width: 140px;
}

.part-content .part-new-table {
  margin: 10px 0;
  border: 1px solid #ebebeb;
  width: 100%;
  max-width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  background-color: transparent;
}

.part-new-table tr th,
.part-new-table tr td {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: middle;
  border: 1px solid #ebebeb;
  text-align: center;
}

.part-new-table tr th {
  background-color: #f8faff;
  color: #999;
  font-weight: normal;
}

.part-new-table p {
  margin-bottom: 0;
}

.part-new-table .check-label {
  font-weight: normal;
}

.part-new-table .check-label input {
  margin-right: 5px;
  margin-top: -2px !important;
}

.content-text .sub-title {
  font-weight: bold;
  color: #333;
}

/*资源播放*/

#res-preview-overlay {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 1000;
  /*background-color: rgba(244, 244, 244, 0.5);*/
}

#res-preview-overlay-bg {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.6;
  filter: alpha(opacity=60);
}

#res-preview-panel {
  background-color: #fff;
  left: 50%;
  margin: 0;
  max-height: 90%;
  overflow-y: auto;
  padding: 20px 10px;
  position: fixed;
  top: 50%;
  height: 600px;
  margin-top: -325px;
  margin-left: -480px;
  width: 960px;
}

#res-preview-title {
  position: relative;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  padding-left: 20px;
  height: 24px;
  line-height: 24px;
}

#res-preview-title .iconfont {
  font-size: 20px;
}

#res-preview-title:before {
  content: "";
  position: absolute;
  background: #73D6CA;
  height: 18px;
  width: 3px;
  left: 0;
  top: 3px;
}

#res-preview-close {
  float: right;
  margin-right: 0;
  font-size: 14px;
  color: #ff2424;
  font-weight: normal;
  cursor: pointer;
}

#res-preview-content {
  padding-top: 20px;
  height: 530px;
  position: relative;
}

#previewPlayer {
  background: #000;
  height: 100%;
}

#res-preview-loading {
  width: 100%;
  height: 100%;
  position: absolute;
  //background:#fff url(/images/loaderBgWhite.gif) no-repeat center;
  top: 0;
  left: 0;
}

#playerContent .nores {
  color: #ccc;
  text-align: center;
  padding-top: 80px;
}

#playerContent {
  margin: 0;
}

#serviceForm .open-more,
#serviceForm .close-more {
  color: #337ab7;
  cursor: pointer;
}

#serviceForm .open-more .iconfont,
#serviceForm .close-more .iconfont {
  margin-left: 2px;
  font-size: 12px;
}

.form_content #basisForm .simple {
  width: 640px;
}
</style>
